<template>
  <div>
    <top-header></top-header>
    <site-header></site-header>
    <!-- 其余内容同理全部粘贴并替换资源路径为@/assets/... -->
    <section class="w3l-main-slider" id="home">
      <el-carousel
        height="650px"
        indicator-position="vertical"
        arrow="hover"
        :autoplay="true"
        :interval="5000"
        style="border-radius: 8px;overflow: hidden;"
      >
        <el-carousel-item v-for="(banner, idx) in banners" :key="banner.id || idx">
          <div class="home-banner-info-bg">
            <img :src="banner.banner_url" alt="banner" />
            <div class="banner-caption">
              <h5>{{ banner.banner_title }}</h5>
              <a
                v-if="banner.redirect_url"
                class="btn btn-style mt-sm-5 mt-4"
                :href="banner.redirect_url"
                target="_blank"
              >
                Know More<i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- banner bottom section -->
    <section class="w3l-bottom-grids-6 pb-lg-5 text-center" id="services">
      <div class="container">
        <div class="grids-area-hny main-cont-wthree-fea row">
          <div class="col-lg-3 col-md-6 px-lg-2">
            <div class="area-box color-1">
              <i class="fa fa-cogs" aria-hidden="true"></i>
              <h4><router-link to="/courses" class="title-head">Chinese & Culture</router-link></h4>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 px-lg-2 mt-md-0 mt-3">
            <div class="area-box color-2">
              <i class="fa fa-book" aria-hidden="true"></i>
              <h4><router-link to="/courses" class="title-head">Learning Management</router-link></h4>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 px-lg-2 mt-lg-0 mt-3">
            <div class="area-box color-3">
              <i class="fa fa-coffee" aria-hidden="true"></i>
              <h4><router-link to="/courses" class="title-head">Fun & <br> Efficient</router-link></h4>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 px-lg-2 mt-lg-0 mt-3">
            <div class="area-box color-4">
              <i class="fa fa-hourglass-half" aria-hidden="true"></i>
              <h4><router-link to="/courses" class="title-head">Gradually Improving</router-link></h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //banner bottom section -->
    <section class="w3l-feature-8">
      <div class="features-main py-5">
        <div class="container py-md-5 py-4">
          <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
            <h3 class="title-main">Welcome to <span>That's Chinese </span></h3>
          </div>
          <div class="row features text-center">
            <template v-if="loading">
              <div class="col-12">
                <div class="loading-container">
                  <i class="el-icon-loading"></i>
                  <p>正在加载数据...</p>
                </div>
              </div>
            </template>
            <template v-else-if="error">
              <div class="col-12">
                <div class="error-container">
                  <i class="el-icon-warning"></i>
                  <p>{{ error }}</p>
                </div>
              </div>
            </template>
            <template v-else-if="introductions.length === 0">
              <div class="col-12">
                <div class="empty-container">
                  <i class="el-icon-document"></i>
                  <p>暂无数据</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-for="(intro, index) in introductions" :key="index" class="col-lg-4 col-sm-6" :class="{'mt-sm-0 mt-5': index === 1, 'mt-lg-0 mt-5': index === 2}">
                <div class="feature-body">
                  <div class="feature-images">
                    <span :class="['fa', index === 0 ? 'fa-graduation-cap' : index === 1 ? 'fa-users' : 'fa-book']" aria-hidden="true"></span>
                  </div>
                  <div class="feature-info mt-4">
                    <router-link to="/about">
                      <h3 class="feature-titel">
                        {{ intro.key }}
                      </h3>
                    </router-link>
                    <p class="feature-text">{{ intro.value }}</p>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- move top -->
    <button @click="topFunction" id="movetop" title="Go to top">
        <span class="fa fa-level-up" aria-hidden="true"></span>
    </button>
    <div class="my_kefu">
        <ul>
            <li>
                <div class="my_kefu_item"><img src="@/assets/images/ewm.png"></div>
                <div class="my_kefu_img"><img id="weixin" src="@/assets/images/ewm.jpg"></div>
            </li>
        </ul>
    </div>

    <!-- courses section -->
    <div class="w3l-grids-block-5 py-5">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">Pick a Course to <span>Get Started</span></h3>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 mt-5" v-for="course in courses" :key="course.id">
            <div class="blog-card-single">
              <div class="grids5-info position-relative">
                <!-- 这里用接口返回的 course_url 作为图片地址 -->
                <ImageWithPlaceholder
                    :src="course.course_url"
                    :height="160"
                />
                <div class="meta-list">
                  <a
                      v-for="label in course.label_names"
                      :key="label"
                      href="javascript:void(0)"
                      class="me-1"
                      :style="{ backgroundColor: getRandomColorForLabel(label) }"
                  >
                    {{ label }}
                  </a>
                </div>

              </div>
              <div class="content-main-top">
                <div class="content-top mb-4 mt-3">
                  <ul class="list-unstyled d-flex align-items-center justify-content-between">
                    <li v-if="course.course_level">
                      <i class="fa fa-signal" aria-hidden="true"></i>
                      {{ course.course_level }}
                    </li>
                  </ul>
                </div>

                <!-- 课程名，点击跳转还是用 course_url 作为链接 -->
                <h4><a :href="course.course_url" target="_blank">{{ course.course_name }}</a></h4>
                <p v-html="$formatTextWithLineBreaks(course.course_content)"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-5">
          <router-link class="btn btn-style btn-style-secondary mt-sm-3" to="/courses">
            Browse more courses<i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
          </router-link>
        </div>
      </div>
    </div>
    <!-- //courses section -->

    <!-- grids section -->
    <section class="w3l-homeblock1">
      <div class="w3-services-ab py-5">
        <div class="container py-md-5 py-4">
          <div class="w3-services-grids pb-sm-5 mb-sm-4">
            <div class="row w3-services-right-grid">
              <div class="col-xl-4">
              </div>
              <div class="col-xl-8">
                <div class="fea-gd-vv row">
                  <div class="col-md-6">
                    <div class="d-flex align-items-center feature-gd">
                      <div class="icon">
                        <i class="fa fa-american-sign-language-interpreting" aria-hidden="true"></i>
                      </div>
                      <div class="icon-info">
                        <h5>Flexible Classes</h5>
                        <p>Private and group classes can both help you learn efficiently.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-md-0 mt-4">
                    <div class="d-flex align-items-center feature-gd">
                      <div class="icon">
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </div>
                      <div class="icon-info">
                        <h5>Offline Mode</h5>
                        <p>Offline Chinese classes and cultural events in China are fun and engaging.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4 pt-md-2">
                    <div class="d-flex align-items-center feature-gd">
                      <div class="icon">
                        <i class="fa fa-headphones" aria-hidden="true"></i>
                      </div>
                      <div class="icon-info">
                        <h5>Teacher Guide</h5>
                        <p>Teachers deliver classes with patience and expertise.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4 pt-md-2">
                    <div class="d-flex align-items-center feature-gd">
                      <div class="icon">
                        <i class="fa fa-play-circle" aria-hidden="true"></i>
                      </div>
                      <div class="icon-info">
                        <h5>Online Classes</h5>
                        <p>Online classes help everyone learn in the world.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //grids section -->

    <!-- stats -->
    <section class="w3_stats py-sm-5 pt-sm-0 pt-5" id="stats">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">Strength in <span>Numbers</span></h3>
          <p class="mt-4 pt-md-2">The numbers can tell you what we have achieved so far.</p>
        </div>
        <div class="w3-stats">
          <div class="row text-center">
            <div class="col-lg-3 col-sm-6">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.COUNTRIES" data-speed="1500"></div>
                <p class="count-text">COUNTRIES</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-sm-0 mt-4">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.SUCCESSFUL_STUDENTS" data-speed="1500"></div>
                <p class="count-text">SUCCESSFUL STUDENTS</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-lg-0 mt-4">
              <div class="counter">
                <div class="timer count-title count-number" :data-to="strengthNumbers.TOTAL_COURSES" data-speed="1500"></div>
                <p class="count-text">TOTAL COURSES</p>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 mt-lg-0 mt-4">
              <div class="counter border-right-0">
                <div class="timer count-title count-number" :data-to="strengthNumbers.YEARLY_TEACHING_HOURS" data-speed="1500"></div>
                <p class="count-text">YEARLY TEACHING HOURS</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //stats -->

    <!-- testimonial section -->
    <div class="w3l-cutomer-main-cont">
      <div class="testimonials py-5">
        <div class="container py-md-5 py-4">
          <div class="title-heading-w3 text-center mx-auto mb-5 pb-lg-5">
            <h3 class="title-main">Student Community <span>Feedback </span></h3>
          </div>
          <div class="row content-sec mt-md-5">
            <div class="col-lg-4 col-md-6 testi-sections">
              <div class="testimonials_grid">
                <p class="sub-test"><q>l liked that the teacher used Chinese language during the class. Even though l didn't understand every word she said, l enjoyed listening and l could guess the meaning. Listening is very important.</q></p>
                <div class="d-grid sub-author-con">
                  <div class="testi-img-res">
                    <img src="@/assets/images/testi2.jpg" alt="" class="img-fluid" />
                  </div>
                  <div class="testi_grid text-left">
                    <h5>Masha Cruis</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mt-md-0 mt-4 testi-sections">
              <div class="testimonials_grid">
                <p class="sub-test"><q>ln general l think teacher did a great job.The preparation of each class was 10/10, l rarely felt that 90 minutes have passed; She created a relaxing atmosphere and is always ready to shoot out a couple of examples for each question weasked so we could understand something better.Creating real life situations, tests, games etc really is very helpful when learning and soaking up a newlanguage, and l think she did it very well.</q></p>
                <div class="d-grid sub-author-con">
                  <div class="testi-img-res">
                    <img src="@/assets/images/testi1.jpg" alt="" class="img-fluid" />
                  </div>
                  <div class="testi_grid text-left">
                    <h5>Aly Pan</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mt-lg-0 mt-4 testi-sections">
              <div class="testimonials_grid">
                <p class="sub-test"><q>I really liked the lessons with my teacher ! She enthusiastically talks and asks interesting questions. Sometimes I asked her to write a transcription(phinin) and she quickly responded to my questions ! Thank you for the wonderful classes and the opportunity to consolidatc the material covered !</q></p>
                <div class="d-grid sub-author-con">
                  <div class="testi-img-res">
                    <img src="@/assets/images/testi3.jpg" alt="" class="img-fluid" />
                  </div>
                  <div class="testi_grid text-left">
                    <h5>博远</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //testimonial section -->

    <!-- team section -->
    <section class="w3l-team py-sm-5 pb-sm-0 pb-5">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">World Class <span>Instructors</span></h3>
        </div>
        <div class="row text-center">
          <div v-for="teacher in teachers" :key="teacher.id" class="col-lg-3 col-sm-6 mt-lg-0 mt-5">
            <div class="team-block-single">
              <div class="team-grids">
                <router-link :to="`/teacher/${teacher.id}`">
                  <img :src="teacher.teacher_image" class="img-fluid" alt="" />
                  <div class="team-info"></div>
                </router-link>
              </div>
              <div class="team-bottom-block p-4">
                <h5 class="member mb-1">
                  <router-link :to="`/teacher/${teacher.id}`">{{ teacher.teacher_name }}</router-link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //team section -->

    <!-- about-2 section -->
    <section class="w3l-about-2 pb-5">
      <div class="container pb-md-5 pb-4 mb-5">
        <div class="row align-items-center justify-content-between">
          <div class="col-lg-5 about-2-secs-right mb-lg-0 mb-4 text-center">
            <img src="@/assets/images/image.png" alt="" class="img-fluid img-responsive m-auto" />
          </div>
          <div class="col-lg-7 about-2-secs-left pr-lg-5">
            <h3 class="title-style mb-sm-3 mb-2">
              Not Sure Where to Begin? <br>Contact Now, We will Help you</h3>
            <div class="mt-4">
              <router-link class="btn btn-style btn-style-secondary mt-3" to="/contact">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //about-2 section -->
    <footer-component></footer-component>

  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import FooterComponent from '@/components/Footer.vue'
import { getConfig } from '@/api/config'
import { getBannerList } from '@/api/banner'
import { getTeacherList } from '@/api/teacher'
import { getCourses } from '@/api/course'
import ImageWithPlaceholder from "@/components/ImageWithPlaceholder.vue";

export default {
  name: 'HomePage',
  components: {
    ImageWithPlaceholder,
    TopHeader,
    SiteHeader,
    FooterComponent
  },
  data() {
    return {
      loading: false,
      error: null,
      strengthNumbers: {
        COUNTRIES: '0',
        SUCCESSFUL_STUDENTS: '0',
        TOTAL_COURSES: '0',
        YEARLY_TEACHING_HOURS: '0'
      },
      introductions: [],
      banners: [],
      teachers: [],
      courses: [],
      labelColorMap: {} // 缓存每个 label 的颜色，避免每次都变
    }
  },
  created() {
    this.fetchStrengthNumbers()
    this.fetchIntroductions()
    this.fetchBanners()
    this.fetchTeachers()
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);

    // 初始化主题切换
    this.initThemeSwitch();

    // 初始化导航栏响应式功能
    this.initNavbarResponsive();

    // 初始化禁用滚动功能
    this.initNoScroll();

    // 初始化返回顶部按钮
    this.initMoveTop();

    // 初始化数字计数
    this.initCounter();
    this.fetchCourseList();
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const header = document.getElementById('site-header');
      if (header) {  // 确保元素存在
        if (window.scrollY >= 80) {
          header.classList.add('nav-fixed');
        } else {
          header.classList.remove('nav-fixed');
        }
      }
    },
    initThemeSwitch() {
      const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
      if (!toggleSwitch) return;  // 如果元素不存在，直接返回

      const currentTheme = localStorage.getItem('theme');

      if (currentTheme) {
        document.documentElement.setAttribute('data-theme', currentTheme);
        if (currentTheme === 'dark') {
          toggleSwitch.checked = true;
        }
      }

      toggleSwitch.addEventListener('change', (e) => {
        if (e.target.checked) {
          document.documentElement.setAttribute('data-theme', 'dark');
          localStorage.setItem('theme', 'dark');
        } else {
          document.documentElement.setAttribute('data-theme', 'light');
          localStorage.setItem('theme', 'light');
        }
      });
    },
    initNavbarResponsive() {
      const navbarToggler = document.querySelector('.navbar-toggler');
      const header = document.getElementById('site-header');
      if (!navbarToggler || !header) return;  // 如果元素不存在，直接返回

      navbarToggler.addEventListener('click', () => {
        header.classList.toggle('active');
      });

      if (window.innerWidth > 991) {
        header.classList.remove('active');
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth > 991) {
          header.classList.remove('active');
        }
      });
    },
    initNoScroll() {
      const navbarToggler = document.querySelector('.navbar-toggler');
      if (!navbarToggler) return;  // 如果元素不存在，直接返回

      navbarToggler.addEventListener('click', () => {
        document.body.classList.toggle('noscroll');
      });
    },
    initMoveTop() {
      const movetop = document.getElementById("movetop");
      if (!movetop) return;  // 如果元素不存在，直接返回

      window.addEventListener('scroll', () => {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          movetop.style.display = "block";
        } else {
          movetop.style.display = "none";
        }
      });
    },
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    initCounter() {
      const statsSection = document.querySelector('.w3-stats');
      if (!statsSection) return;  // 如果元素不存在，直接返回

      const counters = statsSection.querySelectorAll('.count-number');
      const speed = 200;

      const animateCounter = (counter) => {
        const target = +counter.getAttribute('data-to');
        const count = +counter.innerText;
        const inc = target / speed;

        if (count < target) {
          counter.innerText = Math.ceil(count + inc);
          setTimeout(() => animateCounter(counter), 1);
        } else {
          counter.innerText = target;
        }
      };

      const startCounting = () => {
        counters.forEach(counter => {
          counter.innerText = '0';
          animateCounter(counter);
        });
      };

      // 当元素进入视口时开始计数
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            startCounting();
            observer.unobserve(entry.target);
          }
        });
      });

      statsSection.querySelectorAll('.counter').forEach(counter => {
        observer.observe(counter);
      });
    },
    async fetchStrengthNumbers() {
      try {
        const res = await getConfig('STRENGTH_NUMBERS')  // res 是 data 数组
        if (Array.isArray(res)) {
          res.forEach(item => {
            if (item.key && item.value) {
              this.strengthNumbers[item.key] = item.value
            }
          })
          this.$nextTick(() => {
            this.initCounter()
          })
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },
    async fetchIntroductions() {
      try {
        const res = await getConfig('INTRODUCTION')
        if (Array.isArray(res)) {
          this.introductions = res
        }
      } catch (error) {
        console.error('获取介绍数据失败:', error)
      }
    },
    async fetchBanners() {
      try {
        const res = await getBannerList()
        this.banners = Array.isArray(res) ? res : []
      } catch (e) {
        this.banners = []
      }
    },
    async fetchTeachers() {
      try {
        const res = await getTeacherList()
        this.teachers = Array.isArray(res) ? res : []
      } catch (e) {
        this.teachers = []
      }
    },
    async fetchCourseList() {
      try {
        const res = await getCourses({ page: 1, page_size: 3 })
        console.log('接口返回数据:', res)
        this.courses = Array.isArray(res)
            ? res.map(item => ({
              id: item.id,
              course_name: item.course_name,
              course_url: item.course_url || '', // 如果有封面字段就保留
              course_content: item.course_content, // 修复简介字段
              label_names: (item.course_labels || []).map(l => l.label_name),// 修复标签字段
              course_level: item.course_level || ''
            }))
            : []
        console.log(this.courses)
      } catch (e) {
        console.error('获取课程列表失败:', e)
        this.courses = []
      }
    },
    getRandomColorForLabel(label) {
      if (!this.labelColorMap[label]) {
        const colors = ['#1DC295', '#FF9800', '#03A9F4', '#E91E63', '#8BC34A', '#9C27B0', '#607D8B'];
        this.labelColorMap[label] = colors[Math.floor(Math.random() * colors.length)];
      }
      return this.labelColorMap[label];

    }
  }
}
</script>

<style scoped>
.area-box {
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.area-box i {
  font-size: 40px;
  margin-bottom: 20px;
}

.area-box h4 {
  margin: 0;
  text-align: center;
}

.area-box .title-head {
  color: #fff;
  text-decoration: none;
  font-size: 20px;
  line-height: 1.4;
}

.color-1 {
  background: #007bff;
}

.color-2 {
  background: #28a745;
}

.color-3 {
  background: #ffc107;
}

.color-4 {
  background: #dc3545;
}

.area-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.loading-container,
.error-container,
.empty-container {
  padding: 40px 0;
  text-align: center;
}

.loading-container i,
.error-container i,
.empty-container i {
  font-size: 40px;
  margin-bottom: 15px;
  color: #909399;
}

.error-container i {
  color: #F56C6C;
}

.empty-container i {
  color: #909399;
}

.loading-container p,
.error-container p,
.empty-container p {
  margin: 10px 0;
  color: #606266;
}

.error-container .el-button {
  margin-top: 15px;
}

.home-banner-info-bg {
  aspect-ratio: 21/9;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: #000;
  height: auto !important;
  min-height: 200px;
  max-height: 80vh;
}

.home-banner-info-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 44px;
  background: rgba(0,0,0,0.3);
  color: #fff;
  text-align: left;
}

.banner-caption h5 {
  margin: 0 0 10px 0;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
}

::v-deep .el-carousel__item {
  height: 100% !important;
}
</style> 